import React, { useEffect } from 'react';
import styles from './NotFound.module.scss';
import { errorMessages } from '../localizations/translations';
import { useLocationWithState } from '../Routes/useLocationWithState';
import { useNavigateWithHistory } from '../Routes/useNavigateWithHistory';
import { ErrorName } from '../error/errors';
import { useAppFeaturesContext } from '../contexts/AppFeaturesContext/AppFeaturesContext';
import { useNotificationContext } from '../contexts/NotificationContext/NotificationContext';
import { HOME_PATH } from '../Routes/routeNames';

const NotFound: React.FC = () => {
  const { languageCode } = useAppFeaturesContext();
  const location = useLocationWithState();
  const navigate = useNavigateWithHistory();
  const { pushNotification: showNotification } = useNotificationContext();

  useEffect(() => {
    navigate(`/${HOME_PATH}`, { replace: true });

    const message = errorMessages[ErrorName.NOT_FOUND_ERROR][languageCode];
    const notification = {
      id: ErrorName.NOT_FOUND_ERROR,
      message,
      hideAutomatically: true,
    };
    showNotification(notification);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [languageCode, location]);

  return <div className={styles.notFound} />;
};

export default NotFound;
